import { render } from "./dashboardCard.vue?vue&type=template&id=141227f0"
import script from "./dashboardCard.vue?vue&type=script&lang=js"
export * from "./dashboardCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__